"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { points4PayEnquireFormConfig } from './Points4PayEnquireFormConfig';

export function Points4PayEnquireForm() {
  return (
    <MultiStepForm 
      config={points4PayEnquireFormConfig}
      className="points4pay-form"
    />
  );
} 